export default __webpack_public_path__ + "static/media/3-2.6c80b0e3.png";